package com.snakesworld.game.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.material3.ripple
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.snakesworld.game.ui.theme.GameCanvasColors
import com.snakesworld.game.ui.theme.LocalGameCanvasColors
import com.snakesworld.game.ui.theme.appFontFamily
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import snakesworld.shared.generated.resources.Res
import snakesworld.shared.generated.resources.back
import snakesworld.shared.generated.resources.ic_arrow_back

/**
 * Consistent top-left back control used across menu screens.
 * Uses the Compose Resources vector drawable ic_arrow_back plus a BACK label.
 * Ripple is clipped to the full bordered button bounds.
 */
@Composable
fun ScreenBackButton(
    onBack: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    canvasColors: GameCanvasColors = LocalGameCanvasColors.current,
) {
    val shape = RoundedCornerShape(6.dp)
    val interactionSource = remember { MutableInteractionSource() }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        modifier = modifier
            .clip(shape)
            .background(canvasColors.hudBgColor, shape)
            .border(1.dp, canvasColors.gridColor, shape)
            .clickable(
                enabled = enabled,
                interactionSource = interactionSource,
                indication = ripple(bounded = true, color = canvasColors.hudTextColor),
                role = Role.Button,
                onClick = onBack,
            )
            .padding(horizontal = 10.dp, vertical = 8.dp),
    ) {
        Icon(
            painter = painterResource(Res.drawable.ic_arrow_back),
            contentDescription = stringResource(Res.string.back),
            tint = canvasColors.hudTextColor.copy(alpha = if (enabled) 1f else 0.4f),
            modifier = Modifier.size(18.dp),
        )
        Text(
            text = stringResource(Res.string.back),
            color = canvasColors.hudTextColor.copy(alpha = if (enabled) 1f else 0.4f),
            fontSize = 12.sp,
            fontWeight = FontWeight.Bold,
            fontFamily = appFontFamily(),
            letterSpacing = 1.sp,
        )
    }
}
